import React from 'react';
import { CheckIcon } from 'lucide-react';
import { volumes } from '../../data/content';
import { SectionHeading } from '../SectionHeading';
import { CTAButton } from '../CTAButton';
export function Volumes() {
  return <section className="bg-cream px-4 py-16 sm:py-24" aria-labelledby="volumes-title" data-id="element-300" data-mp="2wzyrogkxb6jz">
      <div className="mx-auto max-w-4xl" data-id="element-301" data-mp="2symzq4eku98m">
        <SectionHeading eyebrow="What you’ll find inside" title={<span id="volumes-title" data-id="element-303" data-mp="2o26bzbbahww2">6 Premium Volumes that take you from case to next step</span>} data-id="element-302" data-mp="2t1ra5jimy17q" />

        <div className="mt-12 space-y-5" data-id="element-304" data-mp="2j8k8a8n3t3ce">
          {volumes.map(volume => <article key={volume.number} className="overflow-hidden rounded-3xl bg-white shadow-[0_8px_30px_-14px_rgba(16,33,61,0.25)]" data-id="element-305" data-mp="2ebk3s25wk8ne">
              <div className="bg-brand-dark px-6 py-5 sm:px-8" data-id="element-306" data-mp="299uno83tp4sg">
                <p className="text-xs font-bold uppercase tracking-[0.2em] text-brand-light" data-id="element-307" data-mp="258sqrxxdp4tn">{volume.number}</p>
                <h3 className="mt-1 font-serif text-2xl font-bold leading-tight text-white sm:text-3xl" data-id="element-308" data-mp="20bssi96rt6d3">{volume.title}</h3>
              </div>
              <div className="px-6 py-6 sm:px-8" data-id="element-309" data-mp="37w2tuzmoufb3">
                <p className="text-[16px] leading-relaxed text-ink/85" data-id="element-310" data-mp="37xxd89ib9zd2">{volume.intro}</p>
                <ul className="mt-5 grid gap-x-6 gap-y-2.5 sm:grid-cols-2" data-id="element-311" data-mp="2u690q545h8vk">
                  {volume.items.map(item => <li key={item} className="flex gap-2.5 text-[15px] font-medium leading-snug text-ink" data-id="element-312" data-mp="2y4glrc5ncwck">
                      <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-cta" aria-hidden="true" data-id="element-313" data-mp="3luaxtri56gvr" />
                      <span data-id="element-314" data-mp="3qsui7nh37km0">{item}</span>
                    </li>)}
                </ul>
                <p className="mt-6 border-t border-sand pt-5 text-[16px] font-semibold leading-relaxed text-brand-dark" data-id="element-315" data-mp="3huik70dw5kjj">{volume.outro}</p>
              </div>
            </article>)}
        </div>

        <div className="mt-10" data-id="element-316" data-mp="26fdh3v9uljze">
          <CTAButton label="I want all 6 volumes" data-id="element-317" data-mp="26fn4rc7f7f1x" />
        </div>
      </div>
    </section>;
}